import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);

const initReviewsSlider = () => {
  const slider = document.querySelector(".reviews-swiper");

  new Swiper(slider, {
    speed: 200,
    loop: true,
    breakpoints: {     
      1281: {
        slidesPerView: 5,
        spaceBetween: 20,
        centeredSlides: true,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: true,
      },
      751: {
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 10,
      },
      665: {
        slidesPerView: 2,
        spaceBetween: 10,
        centeredSlides: true,
      },
      580: {
        slidesPerView: 1.7,
        spaceBetween: 10,
        centeredSlides: false,
      },
      530: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: false,
      },
      480: {
        slidesPerView: 1.3,
        spaceBetween: 10,
        centeredSlides: false,
      },
      420: {
        slidesPerView: 1.2,
        spaceBetween: 10,
        centeredSlides: false,
      },
      361: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
      },
    },
    navigation: {
      nextEl: ".reviews-swiper__next",
      prevEl: ".reviews-swiper__prev",
      disabledClass: "last",
    },
    on: {
      init: function () {
        const totalSlides = this.slides.length;

        let i = 0;

        for (let item of this.slides) {
          item.classList.contains("swiper-slide-duplicate") ? i++ : "";
        }
        document.querySelector(".reviews-pagination-total").innerHTML =
          totalSlides - i;
      },
      slideChange: function () {
        const index_currentSlide = this.realIndex + 1;
        document.querySelector(".reviews-pagination-current").innerHTML =
          index_currentSlide;
      },
    },
  });

  refreshFsLightbox();
};

export default initReviewsSlider;
